export const InputError = ({
  error,
  isVisible,
}: {
  error?: string | null;
  isVisible: boolean;
}) => {
  return isVisible && error ? (
    <p className="mb-0 block p-0 !text-s/[100%] font-reg text-error">{error}</p>
  ) : null;
};
